import { coreLibraryInitialised } from "@glamcorner/core-cf-lib/lib/common/gcsession/utils";

// Wrapper for GlamCornerCore.bus, because
// - de-dups code
// - easier to test
// - prevents the app crashing if we forget to check if the core library was initialised
export class Bus {
  public static broadcast(eventName: string, data: Record<any, any>) {
    if (coreLibraryInitialised()) {
      GlamCornerCore.bus.broadcast(eventName, data);
    }
  }

  public static on(eventName: string, options: Record<any, any>, callback: (data: Record<any, any>) => void) {
    if (coreLibraryInitialised()) {
      GlamCornerCore.bus.on(eventName, options, callback);
    }
  }
}
